module.exports = __webpack_public_path__ + "media/images/lp_present_it_word_document-ea8220f0ef5a3b7c85074650b4839391.webp";